export const init = () => {
  const youtubeVideos = document.querySelectorAll('.g-youtube-video');

  if (youtubeVideos.length === 0) return;

  youtubeVideos.forEach((videoItem) => {
    const image = videoItem.querySelector('a');
    const video = videoItem.querySelector('iframe');
    video.classList.add('hidden');
    const autoplayOn = video.src.replace('autoplay=0', 'autoplay=1');
    const autoplayOff = video.src.replace('autoplay=1', 'autoplay=0');

    const toggleAutoplay = () => {
      const isAutoplayEnabled = video.tabIndex !== -1 && !video.classList.contains('hidden');
      setTimeout(() => video.src = isAutoplayEnabled ? autoplayOn : autoplayOff, 500);
    };
    
    const handleImageClick = (event) => {
      event.preventDefault();
      video.src = autoplayOn;
      setTimeout(() => {
        video.classList.remove('hidden');
        image.classList.add('hidden');
      }, 1000);
    };

    image.addEventListener('click', handleImageClick);

    const observer = new MutationObserver(toggleAutoplay);
    observer.observe(video, { attributes: true, attributeFilter: ['tabindex'] });
  });
};